import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "search",
  "use": "search-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"search\">\n    <path fill-rule=\"nonzero\" d=\"M9.09 18.131C4.07 18.131 0 14.073 0 9.066S4.07 0 9.09 0c5.021 0 9.092 4.059 9.092 9.066a9.012 9.012 0 0 1-1.965 5.629c-.01.014 3.783 3.907 3.783 3.907L18.55 20s-3.736-3.89-3.748-3.88a9.068 9.068 0 0 1-5.711 2.011zm0-2.37c3.709 0 6.715-2.997 6.715-6.695 0-3.698-3.006-6.696-6.714-6.696-3.708 0-6.714 2.998-6.714 6.696 0 3.698 3.006 6.695 6.714 6.695z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol